export default import.meta.ROLLDOWN_FILE_URL_2iUcJhvmMa8PHbaOm3_3zA